import React from "react";

export interface DropdownItemProps {
  disabled?: boolean;
  value?: string;
  key?: string | number;
}

class DropdownItem extends React.Component<DropdownItemProps> {
  render() {
    return (
      <option
        value={this.props.value}
        disabled={!!this.props.disabled}
      >
        {this.props.children}
      </option>
    );
  }
}

export default DropdownItem;
